/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wizard_Step_IdeaInputs */

const en_wizard_step_idea = /** @type {(inputs: Wizard_Step_IdeaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe idea`)
};

const id_wizard_step_idea = /** @type {(inputs: Wizard_Step_IdeaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceritakan ide`)
};

/**
* | output |
* | --- |
* | "Describe idea" |
*
* @param {Wizard_Step_IdeaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const wizard_step_idea = /** @type {((inputs?: Wizard_Step_IdeaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wizard_Step_IdeaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_wizard_step_idea(inputs)
	return en_wizard_step_idea(inputs)
});